import React, { FC } from 'react';

import TextField, { Props } from '../Text/TextField';

const PasswordField: FC<Props> = props => (
  <TextField type="password" {...props} />
);

export default PasswordField;
